import React, { useState, FC, FocusEvent, ChangeEvent } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import { MultiLineStringInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import Icon from '../../../@shared/icon';
import useFirstUserAction from '../../hooks/useFirstUserActionState';
import CustomTextLabel from '../@shared/customTextLabel';

const MultipleLineTextField: FC<ValueFieldProps<MultiLineStringInputViewModel>> = (props) => {
  const { field, tracker } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const hasValueOrFocus = hasFocus || props?.value !== '';
  const hasAnyError = !!props?.errors?.length;
  const label = field?.model?.title;
  const id = field?.valueField?.id;
  const name = field?.valueField?.name;
  const rows = field?.model?.rows;
  const FieldValidationErrors = props?.fieldValidationErrorsComponent;
  const placeholder = hasFocus ? field?.model?.placeholderText : '';
  const triggerFirstInteractionGTMEvent = useFirstUserAction();

  const onFocus = (e: FocusEvent<HTMLTextAreaElement>): void => {
    tracker.onFocusField(field, e?.target?.value);
    setHasFocus(true);
  };

  const onBlur = (e: FocusEvent<HTMLTextAreaElement>): void => {
    tracker.onBlurField(field, e?.target?.value);
    setHasFocus(false);
  };

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>): void => {
    props.onChange(field?.valueField?.name, e?.target?.value, props.isValid, []);
    triggerFirstInteractionGTMEvent();
  };

  return (
    <div className="sitecore-jss-form__control">
      <div
        className={`sitecore-jss-form__control sitecore-jss-form__control--text-box sitecore-jss-form__control--text-box-multiline ${
          hasAnyError ? 'sitecore-jss-form__control--has-error sitecore-jss-form__control--text-box-multiline--has-error' : ''
        }`}
      >
        <label htmlFor={id} className={`sitecore-jss-form__label ${hasValueOrFocus ? 'sitecore-jss-form__label--has-focus' : ''}`}>
          <CustomTextLabel label={label} />
        </label>
        <textarea
          rows={rows}
          id={id}
          name={name}
          className="sitecore-jss-form__field sitecore-jss-form__field--text-area"
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder}
          value={props?.value}
          form="novalidatedform"
        />
        <Icon iconName="action-expand-text-field" size={24} extraClassName="sitecore-jss-form__field--text-area-icon" />
      </div>
      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default MultipleLineTextField;
